module.exports = __webpack_public_path__ + "img/down-nx2.56351a14.jpg";